import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import Confirmation from "../App/Confirmation";
import { useGlobalState } from "../Context/GlobalStateContext";
import { getAccessSettings } from "../Shared/Utility";
function ApprovalSettings() {
  const globalState = useGlobalState();
  const [programGridData, setProgramGridData] = useState([]);
  const [programData, setProgramData] = useState({}) as any;

  const [showAnimation, setShowAnimation] = useState(false);

  //MM:: Approval related data
  const [requiredApproval, setRequiredApproval] = useState([]) as any;
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;
  const [requiredApprovalUserFKs, setRequiredApprovalUserFKs] = useState(
    []
  ) as any;

  const [requiredApprovalUserData, setRequiredApprovalUserData] = useState(
    {}
  ) as any;
  const [requiredApprovalUserModal, setRequiredApprovalUserModal] =
    useState(false);

  const [delegateData, setDelegateData] = useState({}) as any;
  const [delegateModal, setDelegateModal] = useState(false);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = programData.IBBProgramID;

    setProgramData((prevState: any) => ({
      ...prevState,
      IBBProgramID: IBBProgramID,
    }));

    IBBProgramGetCompleteGridDataCustom(IBBProgramID);
  }, []);

  useEffect(() => {}, []);

  useEffect(() => {
    if (programData.IBBProgramID > 0) {
      IBBRequiredApprovalGetCompleteDataSetForForeignKeysCustom(
        programData.IBBProgramID
      );
      IBBRequiredApprovalUserGetCompleteGridDataCustom(
        programData.IBBProgramID
      );
    }
  }, [programData.IBBProgramID]);

  function IBBProgramGetCompleteGridDataCustom(IBBProgramID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[1].length > 0) {
            if (!IBBProgramID) {
              setProgramData((prevState: any) => ({
                ...prevState,
                IBBProgramID: result[1][0].IBBProgramID,
              }));
            }
            setProgramGridData(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalGetCompleteDataSetForForeignKeysCustom(
    IBBProgramID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    object.isdeleted = false;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApproval/IBBRequiredApprovalGetCompleteDataSetForForeignKeysCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApprovalUserFKs(result);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalUserGetCompleteGridDataCustom(
    IBBProgramID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApprovalUser/IBBRequiredApprovalUserGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApproval(result[0]);
          setRequiredApprovalUser(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalUserSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovaluserid =
      requiredApprovalUserData.IBBRequiredApprovalUserID;
    object.ibbrequiredapprovalid =
      requiredApprovalUserData.IBBRequiredApprovalID;
    object.name = requiredApprovalUserData.Name;
    object.jobroletitle = requiredApprovalUserData.JobRoleTitle;
    object.userid = requiredApprovalUserData.UserID;
    object.username = requiredApprovalUserData.UserName;
    object.useremail = requiredApprovalUserData.UserEmail;
    object.signingorder = requiredApprovalUserData.SigningOrder;
    object.displayorder = requiredApprovalUserData.DisplayOrder;
    object.issignaturerequired = requiredApprovalUserData.IsSignatureRequired;
    object.isstartsection = requiredApprovalUserData.IsStartSection;
    object.isoverwriteothers = requiredApprovalUserData.IsOverwriteOthers;
    object.isvetoauthority = requiredApprovalUserData.IsVetoAuthority;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApprovalUser/IBBRequiredApprovalUserSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setRequiredApprovalUserModal(false);
          IBBRequiredApprovalUserGetCompleteGridDataCustom(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalUserDeleteRecordCustom(
    IBBRequiredApprovalUserID: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovaluserid = IBBRequiredApprovalUserID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApprovalUser/IBBRequiredApprovalUserDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBRequiredApprovalUserGetCompleteGridDataCustom(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBDelegateSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbdelegateid = delegateData.IBBDelegateID;
    object.ibbrequiredapprovaluserid = delegateData.IBBRequiredApprovalUserID;
    object.delegatedtouserid = delegateData.DelegatedToUserID;
    object.name = delegateData.UserName;
    object.extratextfield1 = delegateData.UserEmail;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBDelegate/IBBDelegateSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setDelegateModal(false);
          IBBRequiredApprovalUserGetCompleteGridDataCustom(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBDelegateDeleteRecordCustom(IBBDelegateID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbdelegateid = IBBDelegateID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBDelegate/IBBDelegateDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBRequiredApprovalUserGetCompleteGridDataCustom(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalUserCopyDataForApprovalSettings(
    IBBProgramIDFrom: number,
    IBBProgramIDTo: number
  ) {
    if (IBBProgramIDTo == 0) IBBProgramIDTo = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramidfrom = IBBProgramIDFrom;
    object.ibbprogramidto = IBBProgramIDTo;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApprovalUser/IBBRequiredApprovalUserCopyDataForApprovalSettings",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApproval(result[0]);
          setRequiredApprovalUser(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBDelegateDeleteRecordCustom(obj.SelectedID)
      }
    }
    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        IBBRequiredApprovalUserDeleteRecordCustom(obj.SelectedID)
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID:0
    });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Approval Settings</a>
        </div>
        
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={programData.IBBProgramID}
                onChange={(e) =>
                  setProgramData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                  }))
                }
              >
                {programGridData &&
                  programGridData.map((Item: any, index: any) => (
                    <option
                      value={Item.IBBProgramID}
                      key={"program" + Item.IBBProgramID}
                    >
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {programData.IBBProgramID > 0 && (
            <>
              {requiredApproval && requiredApproval.length > 0 && (
                <div className="pg-importers appr-grid">
                  {requiredApproval &&
                    requiredApproval.map((item: any, index: any) => (
                      <React.Fragment key={"requiredapproval" + index}>
                        <div className="appr-main">
                          <div className="appr-head">
                            <span>
                              {item.IBBProgramStageName}{" "}
                              {item.IBBProgramStageName &&
                                item.IBBDepartmentName && <> - </>}
                              {item.IBBDepartmentName}
                            </span>
                            <div className="req-right">
                            {getAccessSettings(2, 19) > 1 &&  <a
                                title="Add User"
                                onClick={() => {
                                  let requiredApprovalUserDataLocal = {} as any;
                                  requiredApprovalUserDataLocal.IBBRequiredApprovalID =
                                    item.IBBRequiredApprovalID;
                                  setRequiredApprovalUserData(
                                    requiredApprovalUserDataLocal
                                  );
                                  setRequiredApprovalUserModal(true);
                                }}
                              >
                                <img
                                  src="images/add.svg"
                                  width={15}
                                  height={15}
                                />
                              </a>}
                            </div>
                          </div>
                          <div className="exceptions-right">
                            {requiredApprovalUser &&
                              requiredApprovalUser.map(
                                (itemUser: any, indexUser: any) => (
                                  <React.Fragment
                                    key={"requiredapprovaluser" + indexUser}
                                  >
                                    {item.IBBRequiredApprovalID ==
                                      itemUser.IBBRequiredApprovalID && (
                                      <>
                                        <div className="req-by">
                                          <div className="req-left custom-val">
                                            <span className="req-title"></span>
                                            <span className="req-val">
                                              <div className="wid-25">
                                                {itemUser.IBBDelegateID ==
                                                  0 && (
                                                  <div className="req-right">
                                                  {getAccessSettings(2, 19) > 1 &&  <a
                                                      title="Add Delegate"
                                                      onClick={() => {
                                                        let delegateLocal =
                                                          {} as any;
                                                        delegateLocal.IBBRequiredApprovalUserID =
                                                          itemUser.IBBRequiredApprovalUserID;
                                                        setDelegateData(
                                                          delegateLocal
                                                        );
                                                        setDelegateModal(true);
                                                      }}
                                                    >
                                                      <img
                                                        src="images/add.svg"
                                                        width={15}
                                                        height={15}
                                                      />
                                                    </a>
                                                    } 
                                                  </div>
                                                )}
                                              </div>
                                              {itemUser.JobRoleTitle && (
                                                <> {itemUser.JobRoleTitle} / </>
                                              )}
                                              {itemUser.UserName}

                                              {itemUser.IBBDelegateID > 0 && getAccessSettings(2, 19) > 1 &&  (
                                                <div className="req-left gap-req">
                                                  /{" "}
                                                  {itemUser.DelegatedToUserName}
                                                  <div className="req-right">
                                                    <a
                                                      onClick={() => {
                                                        let itemLocal =
                                                          itemUser;
                                                        setDelegateData(
                                                          itemLocal
                                                        );
                                                        setDelegateModal(true);
                                                      }}
                                                    >
                                                      <img
                                                        src="images/edit.svg"
                                                        width={15}
                                                        height={15}
                                                      />
                                                    </a>
                                                    <a
                                                      // onClick={() => {
                                                      //   IBBDelegateDeleteRecordCustom(
                                                      //     itemUser.IBBDelegateID
                                                      //   );
                                                      // }}
                                                      onClick={() => {
                                                        globalState.setConfirmationObject({
                                                          ShowPopup: true,
                                                          Heading: "Confirmation ",
                                                          Message: "Are you sure you want to delete this record?",
                                                          ID: 1,
                                                          SelectedID:itemUser.IBBDelegateID
                                                        });
                                                      }}
                                                    >
                                                      <img
                                                        src="images/delete.svg"
                                                        width={15}
                                                        height={15}
                                                      />
                                                    </a>
                                                  </div>
                                                </div>
                                              )}
                                            </span>
                                          </div>
                                          <div className="req-right">
                                           {getAccessSettings(2, 19) > 1 && <a
                                              onClick={() => {
                                                let itemLocal = itemUser;
                                                setRequiredApprovalUserData(
                                                  itemLocal
                                                );
                                                setRequiredApprovalUserModal(
                                                  true
                                                );
                                              }}
                                            >
                                              <img
                                                src="images/edit.svg"
                                                width={15}
                                                height={15}
                                              />
                                            </a>
                                            }
                                             {getAccessSettings(2, 19) > 1 &&  <a
                                              // onClick={() => {
                                              //   IBBRequiredApprovalUserDeleteRecordCustom(
                                              //     itemUser.IBBRequiredApprovalUserID
                                              //   );
                                              // }}

                                              onClick={() => {
                                                globalState.setConfirmationObject({
                                                  ShowPopup: true,
                                                  Heading: "Confirmation ",
                                                  Message: "Are you sure you want to delete this record?",
                                                  ID: 2,
                                                  SelectedID:itemUser.IBBRequiredApprovalUserID
                                                });
                                              }}

                                            >
                                              <img
                                                src="images/delete.svg"
                                                width={15}
                                                height={15}
                                              />
                                            </a>}
                                          </div>
                                        </div>

                                        {itemUser.IsStartSection && (
                                          <div className="req-hr"></div>
                                        )}
                                      </>
                                    )}
                                  </React.Fragment>
                                )
                              )}

                            {/* <div className="appr-add">
                            Add approvers for this stage
                          </div> */}
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
              )}
              {requiredApproval && requiredApproval.length == 0 && (
                <>
                  <div
                    className="flex-items"
                    style={{
                      justifyContent: "center",
                      marginBottom: 10,
                      fontSize: 18,
                      marginTop: 100,
                    }}
                  >
                    <b>Copy Settings from</b>
                  </div>
                  <div
                    className="flex-items"
                    style={{ justifyContent: "center" }}
                  >
                    <select
                      style={{ width: 250 }}
                      value={programData.IBBProgramIDCopyFrom}
                      onChange={(e) =>
                        setProgramData((prevState: any) => ({
                          ...prevState,
                          IBBProgramIDCopyFrom: Number(e.target.value),
                        }))
                      }
                    >
                      <option value="0">Please Select</option>
                      {programGridData &&
                        programGridData.map((Item: any, index: any) => (
                          <>
                            {Item.IBBProgramID != programData.IBBProgramID && (
                              <option
                                value={Item.IBBProgramID}
                                key={"program" + Item.IBBProgramID}
                              >
                                {Item.Name}
                              </option>
                            )}
                          </>
                        ))}
                    </select>
                  </div>
                  <div className="help-btns">
                    {programData.IBBProgramIDCopyFrom != null &&
                      programData.IBBProgramIDCopyFrom > 0 && (
                        <a
                          className="btn-primary btn-grid btn-secs"
                          style={{ width: 90 }}
                          onClick={() => {
                            IBBRequiredApprovalUserCopyDataForApprovalSettings(
                              programData.IBBProgramIDCopyFrom,
                              programData.IBBProgramID
                            );
                          }}
                        >
                          Save
                        </a>
                      )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {requiredApprovalUserModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Manage Approval Users</h3>
                <a
                  className="close-help"
                  onClick={() => setRequiredApprovalUserModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="help-row">
                <p>Job Role Title:</p>
                <input
                  value={requiredApprovalUserData.JobRoleTitle}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      JobRoleTitle: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
              <div className="help-row">
                <p>Approver:</p>
                <select
                  key={"FormulaSelect"}
                  className="input-field select-field"
                  value={requiredApprovalUserData.UserID}
                  onChange={(e) => {
                    let UserID = Number(e.target.value);

                    let UserName = "";
                    let UserEmail = "";

                    let filtered = requiredApprovalUserFKs[5]?.filter(
                      (item: any) => item.PID == UserID
                    );

                    if (filtered.length > 0) {
                      UserName = filtered[0].Name;
                      UserEmail = filtered[0].Email;
                    }

                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      UserID: UserID,
                      UserName: UserName,
                      UserEmail: UserEmail,
                    }));
                  }}
                >
                  <option value="0">Please Select</option>
                  {requiredApprovalUserFKs &&
                    requiredApprovalUserFKs[5] &&
                    requiredApprovalUserFKs[5].map((Item: any, index: any) => (
                      <option value={Item.PID} key={"useroption" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="help-row">
                <p>Signing Order:</p>
                <input
                  value={requiredApprovalUserData.SigningOrder}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      SigningOrder: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              <div className="help-row">
                <p>Display Order:</p>
                <input
                  value={requiredApprovalUserData.DisplayOrder}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      DisplayOrder: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              <div className="help-row">
                <p>Signature Required?</p>
                <input
                  type="checkbox"
                  className="input-check"
                  checked={requiredApprovalUserData.IsSignatureRequired}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      IsSignatureRequired:
                        !requiredApprovalUserData.IsSignatureRequired,
                    }))
                  }
                />
              </div>
              <div className="help-row">
                <p>Start New Section?</p>
                <input
                  type="checkbox"
                  className="input-check"
                  checked={requiredApprovalUserData.IsStartSection}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      IsStartSection: !requiredApprovalUserData.IsStartSection,
                    }))
                  }
                />
              </div>
              <div className="help-row">
                <p>Can Overwrite Others?</p>
                <input
                  type="checkbox"
                  className="input-check"
                  checked={requiredApprovalUserData.IsOverwriteOthers}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      IsOverwriteOthers:
                        !requiredApprovalUserData.IsOverwriteOthers,
                    }))
                  }
                />
              </div>
              <div className="help-row">
                <p>Has Veto Authority?</p>
                <input
                  type="checkbox"
                  className="input-check"
                  checked={requiredApprovalUserData.IsVetoAuthority}
                  onChange={(e) =>
                    setRequiredApprovalUserData((prevState: any) => ({
                      ...prevState,
                      IsVetoAuthority:
                        !requiredApprovalUserData.IsVetoAuthority,
                    }))
                  }
                />
              </div>

              <div className="help-btns">
                <a onClick={() => IBBRequiredApprovalUserSaveCustom()}>Save</a>
                <a onClick={() => setRequiredApprovalUserModal(false)}>
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {delegateModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Manage Delegate</h3>
                <a
                  className="close-help"
                  onClick={() => setDelegateModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="help-row">
                <p>Delegate To:</p>
                <select
                  key={"FormulaSelect"}
                  className="input-field select-field"
                  value={delegateData.DelegatedToUserID}
                  onChange={(e) => {
                    let UserID = Number(e.target.value);

                    let UserName = "";
                    let UserEmail = "";

                    let filtered = requiredApprovalUserFKs[5]?.filter(
                      (item: any) => item.PID == UserID
                    );

                    if (filtered.length > 0) {
                      UserName = filtered[0].Name;
                      UserEmail = filtered[0].Email;
                    }

                    setDelegateData((prevState: any) => ({
                      ...prevState,
                      DelegatedToUserID: UserID,
                      UserName: UserName,
                      UserEmail: UserEmail,
                    }));
                  }}
                >
                  <option value="0">Please Select</option>
                  {requiredApprovalUserFKs &&
                    requiredApprovalUserFKs[5] &&
                    requiredApprovalUserFKs[5].map((Item: any, index: any) => (
                      <option value={Item.PID} key={"useroption" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="help-btns">
                <a onClick={() => IBBDelegateSaveCustom()}>Save</a>
                <a onClick={() => setDelegateModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ApprovalSettings;
